import { Grid, Typography, Select, MenuItem, Button, Menu } from '@mui/material';
import { gridSpacing } from 'store/constant';
import * as React from 'react';
import { PieChart } from '@mui/x-charts/PieChart';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
// import ExpensesChart from '../ExpensesChart';
// import ReservedRoomView from './ReservedRoomsTable';
import { useState, useEffect } from 'react';
import { getApi } from 'views/services/api';
import { Box, Container } from '@mui/system';
import { saveAs } from 'file-saver';
import ExpensesChart from './ExpensesChart';
import ReservedRoomView from './Default/ReservedRoomsTable';
import { Stack } from '@mui/system';

// ==============================|| DEFAULT REPORTS ||============================== //

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(2),
  textAlign: 'left',
  color: theme.palette.text.secondary
}));

const GeneralReports = () => {
  const hotel = JSON.parse(localStorage.getItem('hotelData'));
  const [reservationData, setReservationData] = useState([]);
  const [separateFoodData, setSeparateFoodData] = useState([]);
  const [filterType, setFilterType] = useState('today');
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // Helper function to check if two dates are the same day
  const isSameDay = (date1, date2) => {
    return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate();
  };

  // Function to fetch reservation data from the API
  const fetchReservationData = async () => {
    try {
      // const response = await getApi(`api/reservation/viewallcompletedreservations/${hotel._id}`);
      const response = await getApi(`api/reservation/viewallcompletedreservations/${hotel.hotelId}`);
      let filteredData = response.data.reservationData;

      const today = new Date();

      if (filterType === 'today') {
        filteredData = filteredData.filter((item) => {
          const checkOutDate = new Date(item.checkOutDate);
          return isSameDay(checkOutDate, today);
        });
      } else if (filterType === 'weekly') {
        const startOfWeek = getStartOfWeek(today);
        const endOfWeek = getEndOfWeek(today);
        filteredData = filteredData.filter((item) => {
          const checkOutDate = new Date(item.checkOutDate);
          return checkOutDate >= startOfWeek && checkOutDate <= endOfWeek;
        });
      } else if (filterType === 'monthly') {
        const startOfMonth = getStartOfMonth(today);
        const endOfMonth = getEndOfMonth(today);
        filteredData = filteredData.filter((item) => {
          const checkOutDate = new Date(item.checkOutDate);
          return checkOutDate >= startOfMonth && checkOutDate <= endOfMonth;
        });
      }

      setReservationData(filteredData);
    } catch (error) {
      console.error('Error fetching reservation data:', error);
    }
  };

  const getStartOfWeek = (date) => {
    const startOfWeek = new Date(date);
    startOfWeek.setDate(date.getDate() - date.getDay());
    return startOfWeek;
  };

  const getEndOfWeek = (date) => {
    const endOfWeek = new Date(date);
    endOfWeek.setDate(date.getDate() - date.getDay() + 6);
    return endOfWeek;
  };

  const getStartOfMonth = (date) => {
    return new Date(date.getFullYear(), date.getMonth(), 1);
  };

  const getEndOfMonth = (date) => {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
  };

  // function to fetch separate food inv data from the api

  // Function to fetch separate food invoice data from the API
  const fetchBillData = async () => {
    try {
      // const response = await getApi(`api/separatefoodinvoice/view/${hotel._id}`);
      const response = await getApi(`api/separatefoodinvoice/view/${hotel.hotelId}`);
      const invoiceData = response?.data?.InvoiceData || [];

      // Filter data based on different time periods
      const today = new Date();
      const startOfWeek = getStartOfWeek(today);
      const startOfMonth = getStartOfMonth(today);

      const todayPayments = invoiceData.filter((item) => isSameDay(new Date(item.createdDate), today));
      const weekPayments = invoiceData.filter((item) => new Date(item.createdDate) >= startOfWeek);
      const monthPayments = invoiceData.filter((item) => new Date(item.createdDate) >= startOfMonth);

      filterType === 'today'
        ? setSeparateFoodData(todayPayments)
        : filter === 'weekly'
        ? setSeparateFoodData(weekPayments)
        : setSeparateFoodData(monthPayments);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchBillData();
    fetchReservationData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterType]);

  // Calculate total payment for reservations
  const totalReservationPayment = reservationData.reduce((total, reservation) => total + reservation.totalPayment, 0);

  // Calculate total payment for food items
  const totalFoodPayment = reservationData?.reduce((total, reservation) => {
    if (reservation.foodItems && reservation.foodItems.length > 0) {
      return total + reservation.foodItems.reduce((foodTotal, food) => foodTotal + food.price * food.quantity, 0);
    } else {
      return total;
    }
  }, 0);

  // calculate total food payment of separate food bill
  const totalSeparateFoodPayment = separateFoodData?.reduce((total, item) => {
    if (item.totalAmount) {
      return total + item.totalAmount;
    } else {
      return total;
    }
  }, 0);

  // setTotalFoodPayments(totalFoodPayment);

  // Function to generate random color
  const getRandomColor = () => {
    const r = Math.floor(Math.random() * 256);
    const g = Math.floor(Math.random() * 256);
    const b = Math.floor(Math.random() * 256);
    return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
  };

  // Prepare data for the income pie chart
  const pieChartIncomeData = [
    {
      id: 0,
      value: totalReservationPayment,
      label: 'reservation',
      amount: `Rs ${totalReservationPayment}`,
      color: getRandomColor()
    },
    {
      id: 1,
      value: totalSeparateFoodPayment + totalFoodPayment,
      label: 'food',
      color: getRandomColor()
    }
  ];

  // Function to export pie chart data as CSV
  const exportToCSV = () => {
    const csvData = pieChartIncomeData.map((item) => `${item.label},${item.value}`).join('\n');
    const blob = new Blob([csvData], { type: 'text/csv' });
    saveAs(blob, 'income_data.csv');
  };

  // Function to print the PieChart
  const printPieChart = () => {
    const chartDiv = document.getElementById('pie-chart-div');
    if (chartDiv && filterType) {
      const printWindow = window.open('', '_blank');
      printWindow.document.write('<html><head><title>PieChart Print</title></head><body>');
      printWindow.document.write(chartDiv.innerHTML);
      printWindow.document.write('</body></html>');
      printWindow.document.close();
      printWindow.print();
    }
  };

  return (
    <Container>
      <Stack direction="row" alignItems="center" mb={5} justifyContent={'space-between'}>
        <Typography variant="h4">General Reports</Typography>
      </Stack>
      <Grid container spacing={gridSpacing}>
        <Grid item xs={12}>
          <Grid container spacing={gridSpacing}>
            <Grid item xs={12} md={6}>
              <Item>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography variant="h5" sx={{ mb: 2 }}>
                    Incomes ( in Rs )
                  </Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Select value={filterType} onChange={(e) => setFilterType(e.target.value)}>
                      <MenuItem value="today">Today</MenuItem>
                      <MenuItem value="weekly">Weekly</MenuItem>
                      <MenuItem value="monthly">Monthly</MenuItem>
                    </Select>
                    <Button variant="contained" onClick={handleClick} sx={{ ml: 1 }}>
                      Export / Print
                    </Button>
                    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
                      <MenuItem onClick={exportToCSV}>Export to CSV</MenuItem>
                      <MenuItem onClick={printPieChart}>Print</MenuItem>
                    </Menu>
                  </Box>
                </Box>
                <Box id="pie-chart-div">
                  <Grid item xs={12} sm={6} md={6}>
                    <PieChart
                      series={[
                        {
                          data: pieChartIncomeData
                        }
                      ]}
                      width={500}
                      height={340}
                    />
                  </Grid>

                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', flexDirection: 'column' }}>
                    <Typography>Food Income ( Rs {totalSeparateFoodPayment + totalFoodPayment} )</Typography>
                    <Typography>Reservation Income ( Rs {totalReservationPayment} ) </Typography>
                  </Box>
                </Box>
              </Item>
            </Grid>

            <Grid item xs={12} md={6}>
              <Item>
                <ReservedRoomView />
              </Item>
            </Grid>

            <Grid item xs={12} md={12} sx={{ display: 'flex', justifyContent: 'center' }}>
              <Item>
                <ExpensesChart />
              </Item>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

export default GeneralReports;
